/// <reference types="vite/client" />

/** Vite picks up VITE_-prefixed env vars at build time. */
export function apiBase(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL as string | undefined;
  return (fromEnv || 'http://localhost:8000').replace(/\/+$/, '');
}
